"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wishlistMutations = exports.wishlistMutationKeys = void 0;
const wishlist_api_1 = require("./wishlist.api");
exports.wishlistMutationKeys = {
    all: () => ['wishlist'],
    Login: () => [...exports.wishlistMutationKeys.all(), 'WishlistLogin'],
};
const wishlistMutations = (apiOptions) => ({
    wishlistLoginMutation: (options = {}) => (Object.assign(Object.assign({}, options), { mutationKey: exports.wishlistMutationKeys.Login(), mutationFn: (params) => (0, wishlist_api_1.wishlistLogin)(apiOptions, params) })),
});
exports.wishlistMutations = wishlistMutations;
//# sourceMappingURL=wishlist.mutations.js.map